export enum PermissionEntityType {
  Group = 'group',
  User = 'user',
  WorkspaceMember = 'workspace-member',
  ExternalUser = 'external-user',
  Link = 'link',
  System = 'system',
  Bot = 'bot',
  App = 'app',
  Agent = 'agent',
}
